import React from 'react';
import { ErrorMessage } from 'formik';
import BoxWrapper from 'components/atoms/BoxWrapper';
import CustomTypography from 'components/atoms/CustomTypography';
import styled from 'styled-components';
import { colors } from 'theme/Variables';

const StyledErrorMessage = styled.p`
    font-size: 1.2rem;
    color: ${colors.secondary['500']};
    margin-top: 0.5rem;
`;

const WrapperFormControl = ({ instruction, name, children }) => {
    return (
        <BoxWrapper justifyContent="flex-start">
            {children}
            <ErrorMessage
                name={name}
                render={(msg) => <StyledErrorMessage>{msg}</StyledErrorMessage>}
            />
            <CustomTypography fontSize="1.2" mt="0.5">
                {instruction}
            </CustomTypography>
        </BoxWrapper>
    );
};

export default WrapperFormControl;
